import { render, staticRenderFns } from "./HomeNutricionista.vue?vue&type=template&id=506bb9e3&scoped=true"
import script from "./HomeNutricionista.vue?vue&type=script&lang=js"
export * from "./HomeNutricionista.vue?vue&type=script&lang=js"
import style0 from "./HomeNutricionista.vue?vue&type=style&index=0&id=506bb9e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506bb9e3",
  null
  
)

export default component.exports